import { useState } from "react";
import { message, Col, Row, Typography } from "antd";
import { backendPostWithoutRefresh } from "../../../../../helpers/callBackend";
import GenericModal from "../../../../../components/buttons/genericModal";
import LoadingButton from '@mui/lab/LoadingButton';

const { Text } = Typography;

export default function MarkClosed(props) {
  const [visible, setVisible] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const updateAccountInfo = (accountInfo, bankId, response) => {
    return accountInfo.id === bankId ? ({
      ...accountInfo,
      account: {
        ...accountInfo?.account,
        marked_closed: response.data?.data?.account?.marked_closed,
        aggregated_balance: response.data?.data?.account?.aggregated_balance,
        aggregated_balance_raw: response.data?.data?.account?.aggregated_balance_raw,
        available_balance: response.data?.data?.account?.available_balance,
        current_balance: response.data?.data?.account?.current_balance,
        current_balance_raw: response.data?.data?.account?.current_balance_raw
      }
    }) : accountInfo;
  }

  const handleMarkOpen = () => {
    setSubmitting(true);
    const bankId = props.bankAccountId
    backendPostWithoutRefresh(
      "/api/bank-account/update/",
      {
        bank_account_id: bankId,
        marked_closed: false
      },
    ).then((response) => {
      if (response && response.status === 200) {
        if (props.setClosedAccounts && props.setConnectedAccounts) {
          props.setClosedAccounts((prevState) => {
            const updatedList = prevState.filter((account) => account.id !== bankId);
            return updatedList;
          })
          props.setConnectedAccounts((prevState) => {
            const updatedList = [...prevState, response.data?.data];
            return updatedList;
          })
        } else if (props.setAccounts) {
          props.setAccounts((prevState) => {
            const updatedList = prevState.map((accountInfo) => {
              return updateAccountInfo(accountInfo, bankId, response)
            });
            return updatedList;
          })
        }
        setVisible(false);
        setSubmitting(false);
      } else {
        setVisible(false);
        setSubmitting(false);
        message.error(`Failed to update the bank account ${props.record.account.accountDescription}`)
      }
    })
      .catch((error) => {
        setVisible(false);
        setSubmitting(false);
        console.error("Error:", error)
      })
  };

  const handleMarkClosed = () => {
    const bankId = props.bankAccountId
    const sourceAccountId = props.record.source_account_id ? props.record.source_account_id : props.record.account.source_account_id
    setSubmitting(true);
    backendPostWithoutRefresh(
      "/api/bank-account/update/",
      {
        bank_account_id: bankId,
        marked_closed: true,
        source: props.record.account.account_source,
        sourceAccountId: sourceAccountId
      },
    ).then((response) => {
      if (response && response.status === 200) {
        if (props.setClosedAccounts && props.setConnectedAccounts) {
          props.setConnectedAccounts((prevState) => {
            const updatedList = prevState.filter((account) => account.id !== bankId);
            return updatedList;
          })
          props.setClosedAccounts((prevState) => {
            const updatedList = [...prevState, response.data.data];
            return updatedList;
          })
        } else if (props.setAccounts) {
          props.setAccounts((prevState) => {
            const updatedList = prevState.map((accountInfo) => {
              return updateAccountInfo(accountInfo, bankId, response)
            });
            return updatedList;
          })
        }
        setVisible(false);
        setSubmitting(false);
      } else {
        setVisible(false);
        setSubmitting(false);
        message.error(`Failed to update the bank account ${props.record.account.accountDescription}`)
      }
    })
      .catch((error) => {
        setVisible(false);
        setSubmitting(false);
        console.error("Error:", error)
      })
  };

  const modalBodyClose = (
    <div>
      <Col>
        <Row><Text>Are you sure you want to mark this account closed?
          This will stop any data feed for this account.
          If you do not want to proceed or are unsure, please click X on the upper right.
        </Text></Row>
        {props.extra && (
          <Row><Text>{props.extra}</Text></Row>
        )}
        <Row style={{ marginTop: '20px' }}>
          <LoadingButton
            style={{ margin: 'auto' }}
            loading={submitting}
            onClick={handleMarkClosed}
            loadingPosition="start"
            disableElevation fullWidth size="small" type="submit" variant="outlined" color="error"
            sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
          > Mark As Closed </LoadingButton>
        </Row>
      </Col>
    </div>
  );

  const modalBodyOpen = (
    <div>
      <Col>
        <Row><Text>
          Are you sure you want to mark this account as open?
          This is will not re-establish data feeds for this account.
          If you want live data feeds you must re-create the account connection in the Manage Connections page.
          If you do not want to proceed or are unsure, please click X on the upper right.
        </Text></Row>
        {props.extra && (
          <Row><Text>{props.extra}</Text></Row>
        )}
        <Row style={{ marginTop: '20px' }}>
          <LoadingButton
            style={{ margin: 'auto' }}
            loading={submitting}
            onClick={handleMarkOpen}
            loadingPosition="start"
            disableElevation fullWidth size="small" type="submit" variant="outlined" color="error"
            sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
          > Mark As Not Closed </LoadingButton>
        </Row>
      </Col>
    </div>
  );

  return (
    <GenericModal
      type='Bank Account'
      button={props.markedClosed ? 'Mark As Not Closed' : 'Mark As Closed'}
      showModal={() => setVisible(true)}
      size="md"
      visible={visible}
      modalTitle={props.markedClosed ? `Are you sure you want to mark ${props.record.account.account_description} as open?` : `Are you sure you want to mark ${props.record.account.account_description} as closed?`}
      handleCancelModal={() => setVisible(false)}
      modalBody={props.markedClosed ? modalBodyOpen : modalBodyClose}
    >
      {props.markedClosed ? "Mark As Not Closed" : "Mark As Closed"}
    </GenericModal>
  )
};